import { type ImgHTMLAttributes } from "react";
import { cn } from "@/lib/utils";
import mascotSrc from "@/assets/landing/dollarbill-mascot.png";

interface DollarBillIconProps
  extends Omit<ImgHTMLAttributes<HTMLImageElement>, "src" | "width" | "height"> {
  size?: number;
  variant?: "default" | "white" | "dark";
}

export function DollarBillIcon({
  size = 36,
  variant: _variant,
  className,
  style,
  ...props
}: DollarBillIconProps) {
  return (
    <img
      src={mascotSrc}
      alt="Dollar Bill"
      width={size}
      height={size}
      className={cn(
        "rounded-lg shadow-md object-cover",
        className,
      )}
      style={{ width: size, height: size, ...style }}
      {...props}
    />
  );
}
